import request from './request'

// --- 认证 / 仪表盘 / 用户 ---
export function adminLogin(data) {
  return request.post('/admin/auth/login', data)
}

export function getForumAdminEntry() {
  return request.get('/admin/forum/entry')
}

export function getAdminMenus() {
  return request.get('/admin/menus')
}

export function getDashboardStats() {
  return request.get('/admin/dashboard/stats')
}

export function getOpsCredits(params) {
  return request.get('/admin/ops/credits', { params })
}

export function getOpsOnline(params) {
  return request.get('/admin/ops/online', { params })
}

export function getOpsActive(params) {
  return request.get('/admin/ops/active', { params })
}

export function getOpsProfit(params) {
  return request.get('/admin/ops/profit', { params })
}

export function getOpsTest(params) {
  return request.get('/admin/ops/test', { params })
}

export function getUsers(params) {
  return request.get('/admin/users', { params })
}

export function createUser(data) {
  return request.post('/admin/users', data)
}

export function cancelUser(id, data) {
  return request.put(`/admin/users/${id}/cancel`, data || {})
}

export function resetUserPassword(id, data) {
  return request.put(`/admin/users/${id}/password`, data)
}

export function updateUserPhone(id, data) {
  return request.put(`/admin/users/${id}/phone`, data)
}

export function updateUserMembershipExpire(id, data) {
  return request.put(`/admin/users/${id}/membership-expire`, data)
}

export function adjustUserToken(id, data) {
  return request.put(`/admin/users/${id}/token-adjust`, data)
}

export function getUserStats() {
  return request.get('/admin/users/stats')
}

export function getUserDetail(id) {
  return request.get(`/admin/users/${id}`)
}

export function getUserCreditsLedger(id, params) {
  return request.get(`/admin/users/${id}/credits-ledger`, { params })
}

export function getUserComputeCreditsLedger(id, params) {
  return request.get(`/admin/users/${id}/compute-credits-ledger`, { params })
}

export function updateUser(id, data) {
  return request.put(`/admin/users/${id}`, data)
}

export function updateUserStatus(id, status) {
  return request.put(`/admin/users/${id}/status`, { status })
}

export function updateUserTestAccount(id, data) {
  return request.put(`/admin/users/${id}/test-account`, data)
}

export function updateUserMembershipTier(id, data) {
  return request.put(`/admin/users/${id}/membership-tier`, data)
}

export function adjustUserPoints(id, data) {
  return request.put(`/admin/users/${id}/points-adjust`, data)
}

export function getUserAdminChanges(id, params) {
  return request.get(`/admin/users/${id}/admin-changes`, { params })
}

export function getEnterpriseCreatorApplies(params) {
  return request.get('/admin/users/enterprise-applications', { params })
}

export function getEnterpriseCreatorApply(userId) {
  return request.get(`/admin/users/enterprise-applications/${userId}`)
}

export function auditEnterpriseCreator(userId, data) {
  return request.put(`/admin/users/enterprise-applications/${userId}/audit`, data)
}

// --- 需求 ---
export function getDemands(params) {
  return request.get('/admin/demands', { params })
}

export function getDemandStats() {
  return request.get('/admin/demands/stats')
}

export function getDemandDetail(id) {
  return request.get(`/admin/demands/${id}`)
}

export function updateDemandStatus(id, status) {
  return request.put(`/admin/demands/${id}/status`, { status })
}

export function matchDemand(id, data) {
  return request.put(`/admin/demands/${id}/match`, data)
}

export function getMatchRecords(params) {
  return request.get('/admin/demands/matches', { params })
}

export function getMatchStats() {
  return request.get('/admin/demands/matches/stats')
}

export function sendPlatformMessage(id, data) {
  return request.post(`/admin/demands/${id}/platform-message`, data)
}

export function getDemandCategories() {
  return request.get('/admin/demands/categories')
}

export function saveDemandCategory(data) {
  return request.post('/admin/demands/categories', data)
}

export function deleteDemandCategory(id) {
  return request.delete(`/admin/demands/categories/${id}`)
}

// --- 作品分类 ---
export function getWorkCategories() {
  return request.get('/admin/works/categories')
}

export function saveWorkCategory(data) {
  return request.post('/admin/works/categories', data)
}

export function deleteWorkCategory(id) {
  return request.delete(`/admin/works/categories/${id}`)
}

// --- 作品审核 ---
export function getPendingWorks(params) {
  return request.get('/admin/works/pending', { params })
}

export function getAdminWorks(params) {
  return request.get('/admin/works/pending', { params })
}

export function auditWork(id, data) {
  return request.put(`/admin/works/${id}/audit`, data)
}

export function updateWorkSortOrders(orders) {
  return request.put('/admin/works/sort', orders)
}

// --- 反馈 / 评论 ---
export function getFeedback(params) {
  return request.get('/admin/feedback', { params })
}

export function replyFeedback(id, reply) {
  return request.put(`/admin/feedback/${id}/reply`, { reply })
}

export function getFeedbackDetail(id) {
  return request.get(`/admin/feedback/${id}`)
}

export function resolveFeedback(id) {
  return request.put(`/admin/feedback/${id}/resolve`)
}

export function getCourseReviews(params) {
  return request.get('/admin/course-reviews', { params })
}

export function getCourseReviewDetail(id) {
  return request.get(`/admin/course-reviews/${id}`)
}

export function exportCourseReviews(params) {
  return request.get('/admin/course-reviews/export', { params })
}

export function getComments(params) {
  return request.get('/admin/comments', { params })
}

export function banComment(id) {
  return request.put(`/admin/comments/${id}/ban`)
}

export function deleteComment(id) {
  return request.delete(`/admin/comments/${id}`)
}

export function banCommentUser(data) {
  return request.post('/admin/comments/ban-user', data)
}

export function getBannedUsers(params) {
  return request.get('/admin/comments/banned-users', { params })
}

export function unbanUser(userId) {
  return request.delete(`/admin/comments/banned-users/${userId}`)
}

export function getCommentKeywords() {
  return request.get('/admin/comments/keywords')
}

export function saveCommentKeyword(data) {
  return request.post('/admin/comments/keywords', data)
}

// --- 交易 / 流量 ---
export function getPointPackages() {
  return request.get('/public/trade/point-packages')
}

export function getMembershipPlans() {
  return request.get('/admin/trade/membership-plans')
}

export function saveMembershipPlan(data) {
  return request.post('/admin/trade/membership-plans', data)
}

export function getFaqs() {
  return request.get('/admin/faqs')
}

export function saveFaq(data) {
  return request.post('/admin/faqs', data)
}

export function deleteFaq(id) {
  return request.delete(`/admin/faqs/${id}`)
}

export function saveDemand(data) {
  return request.post('/admin/demands/save', data)
}

export function saveWork(data) {
  return request.post('/admin/works/save', data)
}

export function savePointPackage(data) {
  return request.post('/admin/trade/point-packages', data)
}

export function deletePointPackage(id) {
  return request.delete(`/admin/trade/point-packages/${id}`)
}

export function getTrafficCategories() {
  return request.get('/public/trade/traffic-categories')
}

export function saveTrafficCategory(data) {
  return request.post('/admin/trade/traffic-categories', data)
}

export function deleteTrafficCategory(id) {
  return request.delete(`/admin/trade/traffic-categories/${id}`)
}

export function getTrafficProducts(params) {
  return request.get('/admin/trade/traffic-products', { params })
}

export function saveTrafficProduct(data) {
  return request.post('/admin/trade/traffic-products', data)
}

export function deleteTrafficProduct(id) {
  return request.delete(`/admin/trade/traffic-products/${id}`)
}

export function getPromotionOrders(params) {
  return request.get('/admin/trade/promotion-orders', { params })
}

export function updatePromotionExec(id, execStatus) {
  return request.put(`/admin/trade/promotion-orders/${id}/exec`, { execStatus })
}

export function getPayOrders(params) {
  return request.get('/admin/trade/pay-orders', { params })
}

export function refundPayOrder(orderNo, data) {
  return request.post(`/admin/trade/pay-orders/${encodeURIComponent(orderNo)}/refund`, data)
}

// --- CMS ---
export function getCmsCategories(type) {
  return request.get('/admin/cms/categories', { params: { type } })
}

export function getCmsArticles(params) {
  return request.get('/admin/cms/articles', { params })
}

export function getCmsArticleDetail(id) {
  return request.get(`/admin/cms/articles/${id}`)
}

export function saveCmsCategory(data) {
  return request.post('/admin/cms/categories', data)
}

export function deleteCmsCategory(id) {
  return request.delete(`/admin/cms/categories/${id}`)
}

export function saveCmsArticle(data) {
  return request.post('/admin/cms/articles', data)
}

export function deleteCmsArticle(id) {
  return request.delete(`/admin/cms/articles/${id}`)
}

export function resetCmsArticleDownloads(id) {
  return request.put(`/admin/cms/articles/${id}/reset-downloads`)
}

// --- 合规 ---
export function getCopyrightList(params) {
  return request.get('/admin/compliance/copyright', { params })
}

export function getCopyrightDetail(id) {
  return request.get(`/admin/compliance/copyright/${id}`)
}

export function processCopyright(id, data) {
  return request.put(`/admin/compliance/copyright/${id}`, data)
}

export function uploadCopyrightCertificate(id, certificateUrl) {
  return request.put(`/admin/compliance/copyright/${id}`, { certificateUrl })
}

export function getInvoiceList(params) {
  return request.get('/admin/compliance/invoice', { params })
}

export function processInvoice(id, status) {
  return request.put(`/admin/compliance/invoice/${id}`, { status })
}

// --- 代理商 ---
export function getAgents(params) {
  return request.get('/admin/agents', { params })
}

export function updateAgent(id, data) {
  return request.put(`/admin/agents/${id}`, data)
}

export function getCommissionRules() {
  return request.get('/admin/agents/commission-rules')
}

export function saveCommissionRule(data) {
  return request.post('/admin/agents/commission-rules', data)
}

export function deleteCommissionRule(id) {
  return request.delete(`/admin/agents/commission-rules/${id}`)
}

export function getWithdrawals(params) {
  return request.get('/admin/agents/withdrawals', { params })
}

export function processWithdrawal(id, status) {
  return request.put(`/admin/agents/withdrawals/${id}`, { status })
}

export function getCommissions(params) {
  return request.get('/admin/agents/commissions', { params })
}

// --- 系统 ---
export function getAdmins(params) {
  return request.get('/admin/system/admins', { params })
}

export function saveAdmin(data) {
  return request.post('/admin/system/admins', data)
}

export function deleteAdmin(id) {
  return request.delete(`/admin/system/admins/${id}`)
}

export function getRoles() {
  return request.get('/admin/system/roles')
}

export function saveRole(data) {
  return request.post('/admin/system/roles', data)
}

export function deleteRole(id) {
  return request.delete(`/admin/system/roles/${id}`)
}

export function getSystemMenus() {
  return request.get('/admin/system/menus')
}

export function saveSystemMenu(data) {
  return request.post('/admin/system/menus', data)
}

export function deleteSystemMenu(id) {
  return request.delete(`/admin/system/menus/${id}`)
}

export function getSystemConfig() {
  return request.get('/admin/system/config')
}

export function updateSystemConfig(data) {
  return request.put('/admin/system/config', data)
}

export function getSystemNotices(params) {
  return request.get('/admin/system/notices', { params })
}

export function getSystemNoticeDetail(id) {
  return request.get(`/admin/system/notices/${id}`)
}

export function saveSystemNotice(data) {
  return request.post('/admin/system/notices', data)
}

export function deleteSystemNotice(id) {
  return request.delete(`/admin/system/notices/${id}`)
}

export function publishSystemNotice(id) {
  return request.put(`/admin/system/notices/${id}/publish`)
}

export function getOperationLogs(params) {
  return request.get('/admin/system/operation-logs', { params })
}

export function getChannelOverview() {
  return request.get('/admin/channel/overview')
}
export function getChannelPartners() {
  return request.get('/admin/channel/partners')
}
export function saveChannelPartner(data) {
  return request.post('/admin/channel/partners', data)
}
export function reviewChannelPartner(id, data) {
  return request.post(`/admin/channel/partners/${id}/review`, data)
}
export function setChannelReferrer(id, data) {
  return request.post(`/admin/channel/partners/${id}/referrer`, data)
}
export function getChannelPolicies() {
  return request.get('/admin/channel/policies')
}
export function saveChannelPolicy(data) {
  return request.post('/admin/channel/policies', data)
}
export function getChannelVouchers() {
  return request.get('/admin/channel/vouchers')
}
export function updateChannelVoucherProof(id, data) {
  return request.post(`/admin/channel/vouchers/${id}/proof`, data)
}
export function createChannelVoucher(data) {
  return request.post('/admin/channel/vouchers', data)
}
export function reviewChannelVoucher(id, data) {
  return request.post(`/admin/channel/vouchers/${id}/review`, data)
}
export function getChannelSettlements() {
  return request.get('/admin/channel/settlements')
}
export function generateChannelSettlement(period) {
  return request.post('/admin/channel/settlements/generate', null, { params: { period } })
}
export function advanceChannelSettlement(id, data) {
  return request.post(`/admin/channel/settlements/${id}`, data)
}
export function syncChannelConsumption() {
  return request.post('/admin/channel/consumption/sync')
}
export function getChannelStaff() {
  return request.get('/admin/channel/staff')
}
export function addChannelStaff(id, data) {
  return request.post(`/admin/channel/partners/${id}/staff`, data)
}
export function getChannelLines() {
  return request.get('/admin/channel/lines')
}
export function getChannelReports() {
  return request.get('/admin/channel/reports')
}
export function saveChannelReport(data) {
  return request.post('/admin/channel/reports', data)
}
export function getChannelAgreements() {
  return request.get('/admin/channel/agreements')
}
export function saveChannelAgreement(data) {
  return request.post('/admin/channel/agreements', data)
}
export function getChannelDeposits() {
  return request.get('/admin/channel/deposits')
}
export function saveChannelDeposit(data) {
  return request.post('/admin/channel/deposits', data)
}
export function getChannelCourses() {
  return request.get('/admin/channel/courses')
}
export function saveChannelCourse(data) {
  return request.post('/admin/channel/courses', data)
}
export function saveChannelCourseProgress(data) {
  return request.post('/admin/channel/courses/progress', data)
}
export function saveChannelExamConfig(data) {
  return request.post('/admin/channel/exam-config', data)
}
export function getChannelNotices() {
  return request.get('/admin/channel/notices')
}
export function readChannelNotice(data) {
  return request.post('/admin/channel/notices/read', data)
}
export function getChannelWithdrawals() {
  return request.get('/admin/channel/withdrawals')
}
export function saveChannelWithdrawal(data) {
  return request.post('/admin/channel/withdrawals', data)
}
export function reviewChannelReport(id, data) {
  return request.post(`/admin/channel/reports/${id}/review`, data)
}
export function reviewChannelDeposit(id, data) {
  return request.post(`/admin/channel/deposits/${id}/review`, data)
}
export function getChannelAlerts() {
  return request.get('/admin/channel/alerts')
}
export function getChannelQuestions() {
  return request.get('/admin/channel/questions')
}
export function saveChannelQuestion(data) {
  return request.post('/admin/channel/questions', data)
}
export function submitChannelExam(data) {
  return request.post('/admin/channel/exams', data)
}
export function registerChannel(data) {
  return request.post('/public/channel/register', data)
}
export function channelProgress(phone) {
  return request.get('/public/channel/progress', { params: { phone } })
}
export function changeChannelLevel(id, data) {
  return request.post(`/admin/channel/partners/${id}/level`, data)
}
export function changeChannelPassword(id, data) {
  return request.post(`/admin/channel/partners/${id}/password`, data)
}
export function getChannelProfile() {
  return request.get('/admin/channel/profile')
}
export function submitChannelProfile(data) {
  return request.post('/admin/channel/profile', data)
}
export function getChannelProfileChanges() {
  return request.get('/admin/channel/profile-changes')
}
export function reviewChannelProfileChange(id, data) {
  return request.post(`/admin/channel/profile-changes/${id}/review`, data)
}
export function getManagerScopes() {
  return request.get('/admin/channel/scopes')
}
export function saveManagerScope(data) {
  return request.post('/admin/channel/scopes', data)
}
export function saveEcoShare(data) {
  return request.post('/admin/channel/eco-shares', data)
}
export function saveChannelCertificate(data) {
  return request.post('/admin/channel/certificates', data)
}
export function previewChannelInvite(code) {
  return request.get('/public/channel/invite', { params: { code } })
}
export function getEcoDesk() {
  return request.get('/admin/channel/eco/desk')
}
export function getEcoMembers(params) {
  return request.get('/admin/channel/eco/members', { params })
}
export function getEcoWorks(params) {
  return request.get('/admin/channel/eco/works', { params })
}
export function createEcoRecharge(data) {
  return request.post('/admin/channel/eco/recharges', data)
}
export function getPendingEcoRecharges() {
  return request.get('/admin/channel/eco/recharges')
}
export function getEcoRechargeReviews(params) {
  return request.get('/admin/channel/eco/recharges', { params })
}
export function confirmEcoRecharge(id, data) {
  return request.post(`/admin/channel/eco/recharges/${id}`, data)
}
export function refreshEcoRecharge(id) {
  return request.get(`/admin/channel/eco/recharges/${id}`)
}
export function resumeEcoRecharge(id) {
  return request.post(`/admin/channel/eco/recharges/${id}/pay`)
}
export function redeemEcoRebate(data) {
  return request.post('/admin/channel/eco/rebate', data)
}
export function useEcoVoucher(id) {
  return request.post(`/admin/channel/eco/vouchers/${id}/use`)
}
export function allocateEcoPoints(data) {
  return request.post('/admin/channel/eco/allocations', data)
}
export function getEcoTransfers(params) {
  return request.get('/admin/channel/eco/allocations', { params })
}
